export default __webpack_public_path__ + "static/media/AGC_2022_R3_QP_Class_4.48bff741.pdf";